import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc2fbc66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "workout-info" }
const _hoisted_2 = { class: "workout-data" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-clock-o",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { class: "label" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "workout-data" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-road",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_12 = { class: "label" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_14 = { class: "workout-data" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-tachometer",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = { class: "label" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "label" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_21 = {
  key: 0,
  class: "workout-data"
}
const _hoisted_22 = ["alt"]
const _hoisted_23 = { class: "label" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "label" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_28 = {
  key: 1,
  class: "workout-data"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-location-arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_30 = { class: "label" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "label" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(": ")

import { computed, toRefs } from 'vue'

  import WorkoutRecord from '@/components/Workout/WorkoutDetail/WorkoutRecord.vue'
  import WorkoutWeather from '@/components/Workout/WorkoutDetail/WorkoutWeather.vue'
  import { IWorkoutObject } from '@/types/workouts'

  interface Props {
    workoutObject: IWorkoutObject
    useImperialUnits: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    workoutObject: null,
    useImperialUnits: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    workoutObject: IWorkoutObject
    useImperialUnits: boolean
  }

  

  const { workoutObject, useImperialUnits } = toRefs(props)
  const withPause = computed(
    () =>
      props.workoutObject.pauses !== '0:00:00' &&
      props.workoutObject.pauses !== null
  )

return (_ctx: any,_cache: any) => {
  const _component_Distance = _resolveComponent("Distance")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('workouts.DURATION')), 1),
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(workoutObject).moving), 1),
      _createVNode(WorkoutRecord, {
        workoutObject: _unref(workoutObject),
        recordType: "LD"
      }, null, 8, ["workoutObject"]),
      (_unref(withPause))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createTextVNode(" (" + _toDisplayString(_ctx.$t('workouts.PAUSES')) + ": ", 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(workoutObject).pauses), 1),
            _createTextVNode(" - " + _toDisplayString(_ctx.$t('workouts.TOTAL_DURATION')) + ": ", 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(workoutObject).duration) + ")", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('workouts.DISTANCE')), 1),
      _hoisted_13,
      _createVNode(_component_Distance, {
        distance: _unref(workoutObject).distance,
        digits: 3,
        unitFrom: "km",
        strong: true,
        useImperialUnits: _unref(useImperialUnits)
      }, null, 8, ["distance", "useImperialUnits"]),
      _createVNode(WorkoutRecord, {
        workoutObject: _unref(workoutObject),
        recordType: "FD"
      }, null, 8, ["workoutObject"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('workouts.AVERAGE_SPEED')), 1),
      _hoisted_17,
      _createVNode(_component_Distance, {
        distance: _unref(workoutObject).aveSpeed,
        unitFrom: "km",
        speed: true,
        strong: true,
        useImperialUnits: _unref(useImperialUnits)
      }, null, 8, ["distance", "useImperialUnits"]),
      _createVNode(WorkoutRecord, {
        workoutObject: _unref(workoutObject),
        recordType: "AS"
      }, null, 8, ["workoutObject"]),
      _hoisted_18,
      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('workouts.MAX_SPEED')), 1),
      _hoisted_20,
      _createVNode(_component_Distance, {
        distance: _unref(workoutObject).maxSpeed,
        unitFrom: "km",
        speed: true,
        strong: true,
        useImperialUnits: _unref(useImperialUnits)
      }, null, 8, ["distance", "useImperialUnits"]),
      _createVNode(WorkoutRecord, {
        workoutObject: _unref(workoutObject),
        recordType: "MS"
      }, null, 8, ["workoutObject"])
    ]),
    (_unref(workoutObject).maxAlt !== null && _unref(workoutObject).minAlt !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("img", {
            class: "mountains",
            src: "/img/workouts/mountains.svg",
            alt: _ctx.$t('workouts.ELEVATION')
          }, null, 8, _hoisted_22),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('workouts.MIN_ALTITUDE')), 1),
          _hoisted_24,
          _createVNode(_component_Distance, {
            distance: _unref(workoutObject).minAlt,
            unitFrom: "m",
            strong: true,
            useImperialUnits: _unref(useImperialUnits)
          }, null, 8, ["distance", "useImperialUnits"]),
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('workouts.MAX_ALTITUDE')), 1),
          _hoisted_27,
          _createVNode(_component_Distance, {
            distance: _unref(workoutObject).maxAlt,
            unitFrom: "m",
            strong: true,
            useImperialUnits: _unref(useImperialUnits)
          }, null, 8, ["distance", "useImperialUnits"])
        ]))
      : _createCommentVNode("", true),
    (_unref(workoutObject).ascent !== null && _unref(workoutObject).descent !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('workouts.ASCENT')), 1),
          _hoisted_31,
          _createVNode(_component_Distance, {
            distance: _unref(workoutObject).ascent,
            unitFrom: "m",
            strong: true,
            useImperialUnits: _unref(useImperialUnits)
          }, null, 8, ["distance", "useImperialUnits"]),
          _hoisted_32,
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('workouts.DESCENT')), 1),
          _hoisted_34,
          _createVNode(_component_Distance, {
            distance: _unref(workoutObject).descent,
            unitFrom: "m",
            strong: true,
            useImperialUnits: _unref(useImperialUnits)
          }, null, 8, ["distance", "useImperialUnits"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(WorkoutWeather, {
      workoutObject: _unref(workoutObject),
      useImperialUnits: _unref(useImperialUnits)
    }, null, 8, ["workoutObject", "useImperialUnits"])
  ]))
}
}

})